// Schemas Zod para validação de requisições da API

import { z } from 'zod';

// Pagination Schema
export const PaginationSchema = z.object({
  page: z.number().int().min(1, 'Página deve ser um número positivo').default(1),
  limit: z.number().int().min(1).max(100, 'Limite deve ser entre 1 e 100').default(10),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).default('asc')
});

// UUID Param Schema
export const UUIDParamSchema = z.object({
  id: z.string().uuid('ID deve ser um UUID válido')
});

// Query String Schema genérico
export const QueryStringSchema = z.object({
  search: z.string().optional(),
  filters: z.record(z.string()).optional()
}).merge(PaginationSchema);

// Bulk Operation Schema
export const BulkDeleteSchema = z.object({
  ids: z.array(z.string().uuid()).min(1, 'Pelo menos um ID deve ser fornecido')
});

// API Response Schema
export const APIResponseSchema = z.object({
  success: z.boolean(),
  data: z.any().optional(),
  error: z.string().optional(),
  message: z.string().optional(),
  timestamp: z.string().datetime(),
  meta: z.object({
    page: z.number().optional(),
    limit: z.number().optional(),
    total: z.number().optional(),
    hasNext: z.boolean().optional(),
    hasPrev: z.boolean().optional()
  }).optional()
});

// Error Response Schema
export const ErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.string(),
  message: z.string(),
  timestamp: z.string().datetime(),
  path: z.string().optional(),
  statusCode: z.number().int().optional()
});

// Health Check Response Schema
export const HealthCheckSchema = z.object({
  ok: z.boolean(),
  service: z.string(),
  env: z.string(),
  timestamp: z.string().datetime(),
  uptime: z.number(),
  port: z.number()
});

// Export types
export type PaginationType = z.infer<typeof PaginationSchema>;
export type UUIDParamType = z.infer<typeof UUIDParamSchema>;
export type QueryStringType = z.infer<typeof QueryStringSchema>;
export type BulkDeleteType = z.infer<typeof BulkDeleteSchema>;
export type APIResponseType<T = any> = Omit<z.infer<typeof APIResponseSchema>, 'data'> & { data?: T };
export type ErrorResponseType = z.infer<typeof ErrorResponseSchema>;
export type HealthCheckType = z.infer<typeof HealthCheckSchema>;